import angular from 'angular'

angular
  .module('pub.post.comments', ['pub.comments.service'])
  .controller('PostCommentsCtrl', PostCommentsCtrl)

/** @ngInject */
function PostCommentsCtrl($scope, $stateParams, $state, CommentsService) {
  var vm = this
  vm.create = false
  vm.items = []

  function reloadPagination() {
    vm.totalUsers = 0
    vm.usersPerPage = 25
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()
  load(1)

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    CommentsService.get($stateParams.parentId, vm.oldPage, 25).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].editing = false
        if (result.results[i]['ts'] !== undefined) {
          result.results[i]['ts1'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
      }
      vm.items = result.results
    })
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
  }

  vm.back = function() {
    var channelId = localStorage.getItem('channelId')
    if (channelId !== null) {
      $state.go('pub.channels.posts', { parentId: channelId })
    }
  }

  vm.add = function() {
    vm.items.unshift({
      id: 0,
      txt: '',
      'id-po': parseInt($stateParams.parentId),
      editing: true,
    })
    vm.create = true
  }

  vm.edit = function(item) {
    item.editing = !item.editing
  }

  vm.save = function(item) {
    vm.create = false
    if (item.id !== undefined && item.id !== '' && item.id !== 0) {
      CommentsService.update(item.id, item).then(
        function() {
          reloadPagination()
          load()
        },
        function(err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      CommentsService.save(item).then(
        function() {
          reloadPagination()
          load()
        },
        function(err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.cancel = function(item) {
    if (vm.create) {
      vm.items.remove(item)
    }
    vm.create = false
    item.editing = !item.editing
  }

  vm.delete = function(item) {
    CommentsService.remove(item.id).then(
      function() {
        reloadPagination()
        load()
      },
      function(err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.hidden = function(item) {
    var hide = item.h === true ? false : true
    CommentsService.update(item.id, { h: hide }).then(
      function() {
        reloadPagination()
        load()
      },
      function(err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.report = function(item) {
    CommentsService.report(item.id).then(
      function() {
        reloadPagination()
        load()
      },
      function(err) {
        swal(err.error.message, '', 'error')
      },
    )
  }
}
